import {WorkspaceModel} from '../../../models/api/workspaceModel';
import {AppAction} from '../../appActions';
import {DataGroupsActionsEnum} from '../dataGroupsActions';
import {WorkspaceActionsEnum} from './workspaceUpdatedAction';

export function workspaceReducer(state: WorkspaceModel, action: AppAction): WorkspaceModel {
  switch (action.type) {
    case WorkspaceActionsEnum.WORKSPACE_UPDATED: {
      return {
        ...state,
        updatedAt: action.payload.updatedAt,
        value: {
          ...state.value,
          ...action.payload.value,
        },
      };
    }

    case DataGroupsActionsEnum.DATA_UPDATED: {
      const {workspace} = action.payload.result;
      if (!workspace) {
        return state;
      }

      if (!action.payload.shouldIgnoreUpdatedAt && state.updatedAt > workspace.updatedAt) {
        return state;
      }

      return workspace;
    }

    default:
      return state;
  }
}
